import React, { useContext } from 'react';
import { PopoverContext } from './PopoverContext';
import { PopoverFooterContainer } from './styles/popover-footer.styled';
export const PopoverFooter = ({ children, dataTest }) => {
    const { showFade } = useContext(PopoverContext);
    return (React.createElement(PopoverFooterContainer, { "$showFade": showFade, "data-test": dataTest }, children));
};
PopoverFooter.POPOVER_ELEMENT = 'footer';
//# sourceMappingURL=PopoverFooter.js.map